/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeviceFirmwareUpgradeElementResponse
 */
export interface ReportForDeviceFirmwareUpgradeElementResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceFirmwareUpgradeElementResponse
     */
    toVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceFirmwareUpgradeElementResponse
     */
    fromVersion: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceFirmwareUpgradeElementResponse
     */
    upgradedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceFirmwareUpgradeElementResponse
     */
    firstUpgradeOrderAt: Date | null;
}

export function ReportForDeviceFirmwareUpgradeElementResponseFromJSON(json: any): ReportForDeviceFirmwareUpgradeElementResponse {
    return ReportForDeviceFirmwareUpgradeElementResponseFromJSONTyped(json, false);
}

export function ReportForDeviceFirmwareUpgradeElementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceFirmwareUpgradeElementResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'toVersion': json['toVersion'],
        'fromVersion': json['fromVersion'],
        'upgradedAt': (json['upgradedAt'] === null ? null : new Date(json['upgradedAt'])),
        'firstUpgradeOrderAt': (json['firstUpgradeOrderAt'] === null ? null : new Date(json['firstUpgradeOrderAt'])),
    };
}

export function ReportForDeviceFirmwareUpgradeElementResponseToJSON(value?: ReportForDeviceFirmwareUpgradeElementResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'toVersion': value.toVersion,
        'fromVersion': value.fromVersion,
        'upgradedAt': (value.upgradedAt === null ? null : value.upgradedAt.toISOString()),
        'firstUpgradeOrderAt': (value.firstUpgradeOrderAt === null ? null : value.firstUpgradeOrderAt.toISOString()),
    };
}

